export function ArrowReplaceImage(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g id='Icons / Arrows / replaceImage'>
        <path
          id='Vector'
          d='M10.6666 3.8335V5.8335H2.66663V7.16683H10.6666V9.16683L13.3333 6.50016L10.6666 3.8335ZM5.33329 13.1668V11.1668H13.3333V9.8335H5.33329V7.8335L2.66663 10.5002L5.33329 13.1668Z'
          fill='#9CA3AF'
        />
      </g>
    </svg>
  )
}
